import {
    Button,
    Form,
    Upload,
    Input,
    Divider,
    Checkbox,
    Modal,
    Alert,
    Select,
    notification,
    RadioChangeEvent
} from "antd";
import {Radio} from 'antd';
import {MapContainer, Marker, Popup, TileLayer, useMap, useMapEvents} from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import type {CheckboxChangeEvent} from 'antd/es/checkbox';
import MarkerIcon from '../../images/marker.svg'
import {
    DeleteOutlined,
    HomeOutlined,
    IdcardOutlined, MailOutlined,
    MobileOutlined,
    PhoneOutlined,
    PictureOutlined,
    UserOutlined
} from "@ant-design/icons";
import Request from "../../utilis/api/Request";
import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../utilis/contexts/AuthContext";
import {
    Validation,
    WasteWaterBranchAssignmentValidation
} from "../../utilis/tools/validation";
import Urls from "../../utilis/api/Urls";
import Texts from "../../utilis/defaults/Text";
import {RcFile, UploadFile, UploadProps} from "antd/es/upload/interface";
import {getBase64, getMergeImage} from "../../utilis/helpers/imageHelper";

import {ConvertPersianToEnglish} from "../../utilis/helpers/convertor";
import ValueLabel from "../../utilis/models/valueLabel";
import AppContext from "../../utilis/contexts/AppContext";
import serviceCode from "../../utilis/enums/ServiceCode";

import Api from "../../utilis/api/service";
import {AxiosError, AxiosResponse} from "axios";
import LocalStorage from "../../utilis/tools/LocalStorage";
import CardImage from "../../card.png";
import VerifiedUser from "../../utilis/models/verifiedUser";
import ImageDrawer from "../../utilis/tools/ImageDrawer";
import UserVerification from "../UserVerification";
import ServiceResponseTime from "../../utilis/enums/ServiceResponseTime";
import ResponseMessageHandler from "../../utilis/helpers/ResponseMessage";
import Text from "../../utilis/defaults/Text";
import AbfaLogo from "../../images/logo.png"
import {LeafletMouseEvent} from "leaflet";
import {useSearchParams} from "react-router-dom";
import ConfirmInfoModal from "../modals/ConfirmInfoModal";

type Props = {
    orderType: number
}
const WaterBranchAssignment = (props: Props) => {

    const [position, setPosition] = useState<any>(null)
    const appContext = useContext(AppContext)
    const {TextArea} = Input;
    const {Option} = Select;
    const authContext = useContext(AuthContext);
    const [villageLoading, setVillageLoading] = useState(false)
    // @ts-ignore
    const {cities, village_cities, legal_facilities_request_type, construction_document_type} = appContext.globalData;

    // @ts-ignore
    const [data, setData] = useState(authContext.authenticated ? authContext.data : authContext.data.data)

    // @ts-ignore
    const token = authContext.authenticated ? null : authContext.data.token;
    const [authNationalPic, setAuthNationalPic] = useState('')
    const [checkDocument, setCheckDocument] = useState(false)
    const [selectedCity, setSelectedCity] = useState(-1)
    const [legal, setLegal] = useState(-1)
    const [construction, setConstruction] = useState(-1)
    const [agree, setAgree] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    // @ts-ignore

    const [isLoading, setLoading] = useState(false);
    const [constructionLicenseList, setConstructionLicenseList] = useState<UploadFile[]>([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [legalFacilitiesList, setLegalFacilitiesList] = useState<UploadFile[]>([]);
    const [legalFacilitiesBase64, setLegalFacilitiesBase64] = useState('');
    const [constructionLicenseBase64, setConstructionLicenseBase64] = useState('');
    const [neighborBillBase64, setNeighborBillLicenseBase64] = useState('');
    const [neighborBillList, setNeighborBillList] = useState<UploadFile[]>([]);
    const [birthCertificateList, setBirthCertificateList] = useState<UploadFile[]>([]);
    const [birthCertificateBase64, setBirthCertificateBase64] = useState('');
    const [constructionDocumentList, setConstructionDocumentList] = useState<UploadFile[]>([]);
    const [constructionDocumentBase64, setConstructionDocumentBase64] = useState('');
    const [nationalCardList, setnationalCardList] = useState<UploadFile[]>([]);
    const [nationalCardBase64, setNationalCardBase64] = useState('');
    const [village, setVillage] = useState(0);
    //merge-image

    useEffect(() => {
        getMergeImage(legalFacilitiesList, (base64) => {

            setLegalFacilitiesBase64(base64)
        })
    }, [legalFacilitiesList])
    useEffect(() => {
        getMergeImage(nationalCardList, (base64) => {
            setNationalCardBase64(base64)
        })
    }, [nationalCardList])
    useEffect(() => {
        getMergeImage(birthCertificateList, (base64) => {
            setBirthCertificateBase64(base64)
        })
    }, [birthCertificateList])
    useEffect(() => {
        getMergeImage(constructionLicenseList, (base64) => {

            setConstructionLicenseBase64(base64)
        })
    }, [constructionLicenseList]);
    useEffect(() => {
        getMergeImage(constructionDocumentList, (base64) => {
            setConstructionDocumentBase64(base64)
        })
    }, [constructionDocumentList]);
    useEffect(() => {
        getMergeImage(neighborBillList, (base64) => {
            setNeighborBillLicenseBase64(base64)
        })
    }, [neighborBillList]);
    const [previewImage, setPreviewImage] = useState('');
    const legalFacilitiesProps: UploadProps = {
        fileList: legalFacilitiesList,
        onRemove: file => {
            const index = legalFacilitiesList.indexOf(file);
            const newFileList = legalFacilitiesList.slice();
            newFileList.splice(index, 1);
            setLegalFacilitiesList([]);

        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            } else {
                getBase64(file).then((base64) => {
                    let newFile: UploadFile = file
                    newFile.thumbUrl = base64;


                    setLegalFacilitiesList([newFile]);
                    return false
                })


            }


            return false;
        },
    };
    const constructionLicenseProps: UploadProps = {
        fileList: constructionLicenseList,
        onRemove: file => {
            const index = constructionLicenseList.indexOf(file);
            const newFileList = constructionLicenseList.slice();
            newFileList.splice(index, 1);
            setConstructionLicenseList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            } else {
                /*          setConstructionLicenseList([file]);*/
                getBase64(file).then((base64) => {
                    let newFile: UploadFile = file
                    newFile.thumbUrl = base64;


                    setConstructionLicenseList([newFile]);
                    return false
                })

            }


            return false;
        },
    };
    const constructionDocumentProps: UploadProps = {
        fileList: constructionDocumentList,
        onRemove: file => {
            const index = constructionDocumentList.indexOf(file);
            const newFileList = constructionDocumentList.slice();
            newFileList.splice(index, 1);
            setConstructionDocumentList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            } else {
                getBase64(file).then((base64) => {
                    let newFile: UploadFile = file
                    newFile.thumbUrl = base64;


                    setConstructionDocumentList([newFile]);
                    return false
                })


            }

            return false;
        },
    };
    const neighborBillProps: UploadProps = {
        fileList: neighborBillList,
        onRemove: file => {
            const index = neighborBillList.indexOf(file);
            const newFileList = neighborBillList.slice();
            newFileList.splice(index, 1);
            setNeighborBillList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            } else {

                getBase64(file).then((base64) => {
                    let newFile: UploadFile = file
                    newFile.thumbUrl = base64;


                    setNeighborBillList([newFile]);
                    return false
                })


            }

            return false;
        },
    };
    const birthCertificateProps: UploadProps = {
        fileList: birthCertificateList,
        onRemove: file => {
            const index = birthCertificateList.indexOf(file);
            const newFileList = birthCertificateList.slice();
            newFileList.splice(index, 1);
            setNeighborBillList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            } else {
                getBase64(file).then((base64) => {
                    let newFile: UploadFile = file
                    newFile.thumbUrl = base64;


                    setBirthCertificateList([newFile]);
                    return false
                })


            }


            return false;
        },
    };
    const nationalCardProps: UploadProps = {
        fileList: nationalCardList,
        onRemove: file => {
            const index = nationalCardList.indexOf(file);
            const newFileList = nationalCardList.slice();
            newFileList.splice(index, 1);
            setnationalCardList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            }
            getBase64(file).then((base64) => {
                let newFile: UploadFile = file
                newFile.thumbUrl = base64;


                setnationalCardList([newFile]);
                return false
            })


            return false;
        },
    };
    const [hasVillage, setHasVillage] = useState(false);
    const [villages, setVillages] = useState([])
    const [searchable, setSearchable] = useState(true);

    const [nationalCodeRequired, setNationalCodeRequired] = useState(!searchParams.get('isPortal'));
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('');
    const [verificationTry, setVerificationTry] = useState<boolean>(!!searchParams.get('isPortal'));
    const [verifiedUsers, setVerifiedUsers] = useState<Array<VerifiedUser>>([]);

    const handleDeleteVerifiedUser = (index: number) => {
        setVerifiedUsers([
            ...verifiedUsers.slice(0, index),
            ...verifiedUsers.slice(index + 1)
        ]);
    }
    const handleVerificationTry = (hasTry: boolean) => {
        setVerificationTry(hasTry)
    }

    const handleVerifiedUsers = (VerifiedUsers: VerifiedUser) => {

        setVerifiedUsers([...verifiedUsers, VerifiedUsers])
    }

    useEffect(() => {
        if (verifiedUsers.length) {

            setNationalCodeRequired(false)
            ImageDrawer(CardImage, verifiedUsers).then(b64 => {


                setAuthNationalPic(b64)

            })
        } else {
            setAuthNationalPic('')
            if (!!searchParams.get('isPortal')) {
                setNationalCodeRequired(false)
            } else {
                setNationalCodeRequired(true)
            }

        }
    }, [verifiedUsers])

    const handleFirstName = (e: any) => {
        setFirstName(e.target.value)
    }
    const handleLastName = (e: any) => {
        setLastName(e.target.value)
    }
    const onPreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };
    const handleCancel = () => setPreviewOpen(false);
    const handleDocumentCheckbox = (e: CheckboxChangeEvent) => {
        setCheckDocument(e.target.checked)
    };
    const handlePrint = (text: string, name: string, traceNumber: string, address: string, orderType: string, mobile: string) => {
        // @ts-ignore

        // @ts-ignore
        var newWin = window.open('', '', 'height=650, width=650');
        // @ts-ignore
        newWin.document.write('');
        // @ts-ignore

        // @ts-ignore
        newWin.document.write(`
            <div style="margin-bottom: 4px;display: flex; justify-content: center;font-family:'iranSans';"><h3>اداره آب و فاضلاب مازندران</h3></div>
            <div style="border: 1px solid #5e5d5d;border-radius: 7px">
                        <p style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">${text}
        </p>
     
                <div style="direction:rtl;display: flex;justify-content: start;flex-wrap: wrap;font-family:'iranSans';">
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">نام و نام خانوادگی : ${name}</span>
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">کد رهگیری : ${traceNumber}</span>
                 <span style="padding: 10px;font-family:'iranSans';">نوع درخواست : ${orderType}</span>
                 <span style="padding: 10px;font-family:'iranSans';">موبایل : ${mobile}</span>
                 <span style="padding: 10px;font-family:'iranSans';">آدرس : ${address}</span>
        </div>
            </div>
                                   <div style="display: flex;justify-content: center;align-items: center;">
            <img style="width:250px;height: auto;margin-top: 50px; opacity: 80%" src="${AbfaLogo}" alt="">
</div>
        `);
        // @ts-ignore

        // @ts-ignore
        // @ts-ignore
        newWin.document.close();
        // @ts-ignore
        newWin.print();
    }
    const handleSubmit = (values: any) => {
        if (!position) {
            notification['error']({
                message: 'موقعیت مکانی را انتخاب کنید.',

                duration: 120
            });
            return;
        }
        if (selectedCity === -1) {
            notification['error']({
                message: 'لطفا شهر مورد نظر را انتخاب کنید',

                duration: 120
            });
        } else if (hasVillage && village === 0) {
            notification['error']({
                message: 'لطفا روستای مورد نظر را انتخاب کنید',

                duration: 120
            });
        } else if (legal === -1) {
            notification['error']({
                message: 'لطفا نوع درخواست تسهیلات قانونی را انتخاب کنید',

                duration: 120
            });
        } else if (construction === -1) {
            notification['error']({
                message: 'لطفا نوع سند ملک را انتخاب کنید',

                duration: 120
            });
        } else if (!verificationTry) {
            notification['error']({
                message: 'خطا',
                description: 'برای ثبت درخواست باید احراز هویت کدملی را انجام دهید',
                duration: 120
            });
            return;
        } else if ((nationalCardBase64 === "" || nationalCardBase64 === null) && nationalCodeRequired) {

            notification['error']({
                message: 'به علت عدم احراز هویت از طریق کد ملی ، تصویر کارت ملی الزامیست',
                duration: 120
            });
        } else if ((birthCertificateBase64 === "" || birthCertificateBase64 === null) && nationalCodeRequired) {

            notification['error']({
                message: 'به علت عدم احراز هویت از طریق کد ملی ، تصویر شناسنامه متقاضی و مشترک  الزامیست',

                duration: 120
            });
        } else if (constructionDocumentBase64 === "") {

            notification['error']({
                message: 'سند نوع ملک و متن قرارداد الزامیست',

                duration: 120
            });
        } else {

            const body = {
                "Token": token,
                "ServiceType": serviceCode.WaterBranchAssignment,
                "Cellphone": authContext.authenticated ? authContext.user.cellphone : data.cellphone,
                "NationalCode": ConvertPersianToEnglish(values.nationalCode),
                "PostalCode": ConvertPersianToEnglish(values.postalCode),
                "TelNumber": ConvertPersianToEnglish(values.tel),
                "MobileNumber": ConvertPersianToEnglish(values.mobile),
                "FirstName": values.firstName,
                "LastName": values.lastName,
                "City": selectedCity,
                "Email": values.email,
                "Address": values.newAddress,
                "IsLegal": checkDocument ? 1 : 0,
                "RequestType": hasVillage ? 1 : 0,
                "Village": hasVillage ? village : null,
                LegalFacilitiesRequestType: legal,
                ConstructionDocumentType: construction,
                HasCertificate: checkDocument,
                "ConstructionLicensePic": constructionLicenseBase64,
                "Plaque": values.plaque ? ConvertPersianToEnglish(values.plaque) : null,
                "ConstructionDocumentPic": constructionDocumentBase64,
                "BirthCertificatePic": nationalCodeRequired ? birthCertificateBase64 : authNationalPic,
                "NeighborBillPic": neighborBillBase64,
                "NationalCardPic": nationalCodeRequired ? nationalCardBase64 : authNationalPic,
                "LegalFacilitiesPic": legalFacilitiesBase64,
                "lat": position?.lat,
                "long": position?.lng
            };
            const requestTypes = legal_facilities_request_type.filter((requestType: any) => requestType.value == legal);
            const constructionDocs = construction_document_type.filter((cd_type: any) => cd_type.value == construction);
            const currentCity = hasVillage ? village_cities : cities;
            const filteredCities = currentCity.filter((city: any) => city.value == selectedCity);
            const filteredVillages = villages.length > 0 ? villages.filter((vil: any) => vil.id == village) : [];
            // @ts-ignore
            const villageName= filteredVillages.length > 0 ? filteredVillages[0]?.name : "";

            const modalData = {
                ...body,
                requestTypeName: requestTypes.length > 0 ? requestTypes[0].label : "",
                constructionDocName: constructionDocs.length > 0 ? constructionDocs[0].label : "",
                cityName: filteredCities.length > 0 ? filteredCities[0].label : "",
                villageName,
            }
            Modal.confirm({
                direction: "rtl",
                title: 'آیا از صحت اطلاعات اطمینان دارید؟',
                content: <ConfirmInfoModal data={modalData} type={"WaterBranchAssignment"}/>,
                onOk: () => handleRequest(body, values),
                closable: true,
                centered: true,
                okText: "تایید و ارسال",
                cancelText: "بستن",
                width: 800,
            })


        }


    }
    const handleRequest = (body: any, values: any) => {

        Request(Urls.WaterBranchAssignment, body).then((response: any) => {
            console.log(response)
            const key = `open${Date.now()}`;
            notification['success']({
                message: response.message,
                description: ResponseMessageHandler(ServiceResponseTime.WaterBranchAssignment, response.data.trace_number),
                duration: 120,
                key: key,
                btn: <Button type="primary" size="small" onClick={() => {
                    const name = verifiedUsers.length ? verifiedUsers[0].firstName + " " + verifiedUsers[0].lastName : values.firstName + " " + values.lastName;
                    handlePrint(ResponseMessageHandler(ServiceResponseTime.WaterBranchAssignment, response.data.trace_number), name, response.data.trace_number, body.Address, Text.WaterBranchAssignment, values.mobile);
                    notification.destroy()
                }}>
                    چاپ
                </Button>
            });
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })
    }
    const handleCity = (value: number) => {
        const Token = LocalStorage.getToken();
        setSelectedCity(value);
        setVillage(-1)
        if (hasVillage) {

            setVillageLoading(true);
            setVillages([])
            return Api.post(Urls.getVillages, {
                CityId: value,
                Cellphone: authContext.authenticated ? authContext.user.cellphone : data.cellphone
            }, {
                headers: {
                    "Authorization": Token.token_type + " " + Token.access_token
                }
            }).then(function (response: AxiosResponse) {

                if (response.data.Data.villages == false) {
                    setVillages([])
                } else {
                    setVillages(response.data.Data.villages)
                }

            }).catch(function (error: AxiosError) {
                //;

            }).finally(() => {
                setVillageLoading(false)
            });
        }


    }
    const handleVillage = (value: number) => {

        setVillage(value)

    }
    const handleConstruction = (value: number) => {

        setConstruction(value)
    }
    const handleLegal = (value: number) => {

        setLegal(value)
    }
    const onFinishFailed = (error: any) => {

    }

    const onChange = (e: RadioChangeEvent) => {
        handleCity(-1)
        handleVillage(0)
        if (e.target.value === "city") {

            setHasVillage(false);
        } else {
            setHasVillage(true)
        }


    };
    const onChangeAgree = (e: CheckboxChangeEvent) => {
        setAgree(e.target.checked)
    }


    return <>
        <Form
            name="basic"
            className="w-full flex flex-col"
            layout='vertical'
            initialValues={
                {
                    firstName: data?.first_name ? data?.first_name : '',
                    lastName: data?.last_name ? data?.last_name : '',
                    postalCode: data?.postal_code ? data?.postal_code : '',
                    newAddress: data?.address ? data?.address : '',
                    nationalCode: !!searchParams.get('isPortal') ? data.national_code : ''
                }
            }
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}
            autoComplete="off" scrollToFirstError={true}
        >
            <Radio.Group defaultValue="city" onChange={onChange} className="mb-2" buttonStyle="solid">
                <Radio.Button value="village">روستایی</Radio.Button>
                <Radio.Button value="city">شهری</Radio.Button>

            </Radio.Group>

            <Form.Item label={"شهر"}>
                {
                    hasVillage ? <Select showSearch filterOption={(input, option) => {

                        return (option?.children + "" ?? '').includes(input)
                    }} size="large" onChange={handleCity} className="w-full">
                        {village_cities.map((city: ValueLabel) => <Option key={"city-" + city.value}
                                                                          value={city.value}>
                            {city.label}
                        </Option>)}
                    </Select> : <></>
                }
                {
                    !hasVillage ? <Select showSearch filterOption={(input, option) => {

                        return (option?.children + "" ?? '').includes(input)
                    }} size="large" onChange={handleCity} className="w-full">
                        {cities.map((city: ValueLabel) => <Option key={"city-" + city.value}
                                                                  value={city.value}>
                            {city.label}
                        </Option>)}
                    </Select> : <></>
                }


            </Form.Item>
            <Form.Item label={"روستا"}>
                <Select loading={villageLoading} showSearch disabled={!hasVillage} filterOption={(input, option) => {
                    return (option?.children + "" ?? '').includes(input)
                }} size="large" onChange={handleVillage} className="w-full">
                    <>
                        {villages.map((village: any) => <Option key={"village-" + village.name}
                                                                value={village.id}>
                            {village.name}
                        </Option>)}
                    </>
                </Select>
            </Form.Item>
            <Form.Item
                label="نام"
                name="firstName"
                rules={[Validation(WasteWaterBranchAssignmentValidation)]}

            >
                <Input disabled={!!searchParams.get('isPortal')} onChange={handleFirstName} size="large"
                       placeholder="مثلا علی"
                       prefix={<UserOutlined className="text-gray-50"/>}/>
            </Form.Item>
            <Form.Item

                label="نام خانوادگی"
                name="lastName"
                rules={[Validation(WasteWaterBranchAssignmentValidation)]}
            >
                <Input disabled={!!searchParams.get('isPortal')} onChange={handleLastName} size="large"
                       placeholder="مثلا حسینی"
                       prefix={<UserOutlined className="text-gray-50"/>}/>
            </Form.Item>
            {!searchable && <Form.Item
                label="کد ملی"
                name="nationalCode"
                rules={[Validation(WasteWaterBranchAssignmentValidation)]}

            >
                <Input type="tel" size="large" placeholder="مثلا ۴۹۸۰۲۳۴۰۹۶"
                       prefix={<IdcardOutlined className="text-gray-50"/>}/>
            </Form.Item>}


            {searchable &&
                <UserVerification showAuthButton={!searchParams.get('isPortal')} verifiedUsers={verifiedUsers}
                                  data={data}
                                  handleVerificationTry={handleVerificationTry}
                                  handleVerifiedUsers={handleVerifiedUsers}/>}


            <div className="mt-2 mb-2">
                <Alert className="mb-2 mt-2" message="برای ثبت درخواست ابتدااحراز هویت از طریق کد ملی را انجام دهید."
                       type="error"/>
            </div>
            <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
                {verifiedUsers.map((verifiedUser: VerifiedUser, index) => {
                    return <div key={'modal-item' + index} className="p-3 mb-2 border rounded-xl bg-gray-50">


                        <div className="w-full grid gap-3 grid-cols-1 text-sm  md:grid-cols-2">
                            <div><strong>نام : </strong><span>{verifiedUser.firstName}</span></div>
                            <div><strong>نام خانوادگی : </strong><span>{verifiedUser.lastName}</span></div>
                            <div><strong>تاریخ تولد : </strong><span>{verifiedUser.birthDate}</span></div>
                            <div><strong>کد ملی : </strong><span>{verifiedUser.nationalCode}</span></div>
                            <div/>
                            <div className="flex justify-end items-center"><Button type="primary"
                                                                                   onClick={() => handleDeleteVerifiedUser(index)}
                                                                                   size="small" danger
                                                                                   icon={<DeleteOutlined/>}/></div>
                        </div>
                    </div>
                })}
            </div>
            <Form.Item
                label=" کد پستی محل مورد تقاضا"
                name="postalCode"
                rules={[Validation(WasteWaterBranchAssignmentValidation)]}

            >
                <Input disabled={!!searchParams.get('isPortal')} type="tel" size="large" placeholder="مثلا ۴۹۸۰۲۳۴۴۴۱"
                       prefix={<HomeOutlined className="text-gray-50"/>}/>
            </Form.Item>
            <Form.Item
                label="ایمیل"
                name="email"
                requiredMark="optional"

                rules={[Validation(WasteWaterBranchAssignmentValidation)]}
            >
                <Input size="large" placeholder="example@gmail.com"
                       prefix={<MailOutlined className="text-gray-50"/>}/>
            </Form.Item>

            <Form.Item
                label="آدرس محل مورد تقاضا"
                name="newAddress"
                rules={[Validation(WasteWaterBranchAssignmentValidation)]}
            >
                <TextArea disabled={!!searchParams.get('isPortal')} placeholder="..."/>
            </Form.Item>
            <small>نمونه: ساری - بلوار خزر - جنب بانک صادرات ساختمان شماره ۲ آب و فاضلاب استان</small>
            <Form.Item
                label="تلفن ثابت"
                name="tel"

                rules={[Validation(WasteWaterBranchAssignmentValidation)]}
            >
                <Input size="large" prefix={<PhoneOutlined className="text-gray-50"/>}
                       placeholder="مثلا ۰۱۱۳۵۷۵۵۳۴۳"/>
            </Form.Item>

            <Form.Item
                label="تلفن همراه"
                name="mobile"
                initialValue={authContext.authenticated ? authContext.user.cellphone : ''}
                rules={[Validation(WasteWaterBranchAssignmentValidation)]}
            >
                <Input size="large" placeholder="مثلا ۰۹۲۱۰۹۱۳۲۳۲"
                       prefix={<MobileOutlined className="text-gray-50"/>}/>
            </Form.Item>
            <Form.Item
                label="شماره پلاک ثبتی"
                name="plaque"
                requiredMark={"optional"}

            >
                <Input size="large" placeholder="مثلا ۳۴"/>
            </Form.Item>

            <Form.Item className="mt-1" label={"نوع درخواست تسهیلات قانونی"}>
                <Select size="large" onChange={handleLegal} className="w-full">
                    <>
                        {legal_facilities_request_type.map((legalFacilitiesRequest: ValueLabel) => <Option
                            key={"legalFacilitiesRequest-" + legalFacilitiesRequest.value}
                            value={legalFacilitiesRequest.value}>
                            {legalFacilitiesRequest.label}
                        </Option>)}
                    </>
                </Select>
            </Form.Item>
            <Form.Item label={"نوع سند ملک"}>
                <Select size="large" onChange={handleConstruction} className="w-full">
                    <>
                        {construction_document_type.map((constructionDocument: ValueLabel) => <Option
                            key={"city-" + constructionDocument.value}
                            value={constructionDocument.value}>
                            {constructionDocument.label}
                        </Option>)}
                    </>
                </Select>
            </Form.Item>
            <div className="mt-2 mb-2">
                <Alert className="mb-2 mt-2"
                       message="  کلیه تصاویر ارسالی باید در یکی از فرمت های jpg،tif،tiff،jpeg باشد." type="info"/>
            </div>
            <div className="flex justify-start  mb-2">
                <Checkbox onChange={handleDocumentCheckbox}>املاک فاقد مجوز قانونی با ارائه تعهد نامه محضری</Checkbox>
            </div>
            <Form.Item
                label={Texts.constructionLicensePic + "(   پروانه ساختمانی پایان کار , کمیسیون ماده۱۰۰ , نامه شهرداری مبنی بر بلا‌ مانع بودن\n" +
                    "                واگذاری انشعاب می باشد)"}
                name="constructionLicense">
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} disabled={checkDocument}
                        onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...constructionLicenseProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>
            <Divider/>
            <Form.Item
                label={Texts.legalFacilitiesPic}
                name="legalFacilities"
                requiredMark="optional"
            >
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...legalFacilitiesProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>
            <Divider/>
            {nationalCodeRequired && verificationTry && <Form.Item
                label={Texts.birthCertificatePic + " متقاضی و مشترک"}
                name="birthCertificate">
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...birthCertificateProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>}
            <Divider/>

            {
                nationalCodeRequired && verificationTry && <Form.Item
                    label={Texts.nationalCardPic}
                    name="nationalCard">
                    <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                            listType="picture-card" maxCount={1}  {...nationalCardProps}>
                        <PictureOutlined/>
                    </Upload>
                </Form.Item>
            }

            <Divider/>
            <Form.Item
                label={Texts.neighborBill}
                name="neighborBill"
                requiredMark="optional"
            >
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...neighborBillProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>


            <Form.Item
                label={Texts.constructionDocumentPic}
                name="constructionDocument"
            >
                <a target="_blank"
                   href="https://www.abfa-mazandaran.ir//dorsapax/Data/Sub_0/File/gharadadab.pdf"><small>{'مشاهده متن قرار داد'}</small></a>
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...constructionDocumentProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>
            <div className="w-full h-72">
                <h1>موقعیت مکانی خود را انتخاب کنید.</h1>
                <MapContainer
                    center={{
                        lat: 36.553622265632384, lng:
                            53.05735588073731
                    }}
                    id="map"
                    zoom={10}
                    className="h-full"
                    scrollWheelZoom={true}>
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    <MapComponent onClick={(value: any) => {
                        setPosition(value)
                    }}/>
                </MapContainer>
            </div>
            <div className="w-full mb-4 mt-10">
                <Checkbox onChange={onChangeAgree}>اینجانب {firstName + " " + lastName} اطلاع کامل فرم فوق، متن قرارداد
                    و
                    تصاویر مدارک خواسته شده با صداقت تکمیل و ارسال نموده و چنانچه خلاف آن ثابت شود شرکت مجاز به قطع
                    انشعاب فوق بوده و وصل مجدد آن منوط به تسویه حساب کامل بر اساس تعرفه جاری (قیمت روز) می باشد و حق
                    هرگونه اعتراض را از خود سلب می نمایم.</Checkbox>
            </div>

            <Form.Item className="w-full mt-4">
                <Button loading={isLoading} disabled={!agree} size="large" type="primary"
                        className="bg-primary w-full  md:w-[150px]"
                        htmlType="submit">
                    ثبت درخواست
                </Button>
            </Form.Item>

        </Form>

        <Modal open={previewOpen} title="تصویر" footer={null} onCancel={handleCancel}>
            <img alt="example" style={{width: '100%'}} src={previewImage}/>
        </Modal>

    </>
}
type MapProps = {
    onClick: Function
}

function MapComponent(props: MapProps) {
    const {onClick} = props;
    const [position, setPosition] = useState<any>({
        lat: null, lng: null
    })
    const myIcon = new L.Icon({
        iconUrl: MarkerIcon,
        iconRetinaUrl: MarkerIcon,
        popupAnchor: [-0, -0],
        iconSize: [32, 45],

    });
    const map = useMapEvents({
        click: (location) => {

            setPosition(location.latlng);
            onClick(location.latlng)
        }
    })
    return position.lat === null ? null : (
        <Marker icon={myIcon} position={position}>
            <Popup>مکان انتخابی شما</Popup>
        </Marker>
    )
}


export default WaterBranchAssignment;